var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.searchSelect),function(item,i){return _c('renderItem',{key:i,attrs:{"mantra":_vm.mantras[_vm.searchSelect[i].mantra_id],"mantra_id":_vm.searchSelect[i].mantra_id,"script":_vm.script,"mantras":_vm.mantras}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }